import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Prompt, useHistory } from "react-router-dom";
import Button from "../Button";
import styles from "./LeavingGuard.module.scss";

interface Props {
  when: boolean;
  message: string;
  title: string;
}

export default function LeavingGuard(props: Props) {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState<string | undefined>(
    undefined,
  );
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const history = useHistory();

  function showModal(location: string) {
    setModalVisible(true);
    setLastLocation(location);
  }

  function handleBlockedNavigation(nextLocation: string) {
    /* magically display the modal instead of prompt */
    if (!confirmedNavigation && props.when) {
      showModal(nextLocation);
      return false;
    }
    return true;
  }

  function handleConfirmNavigationClick() {
    /* confirmed navigation away */
    setModalVisible(false);
    if (lastLocation) {
      setConfirmedNavigation(true);
    }
  }

  /* biome-ignore lint/correctness/useExhaustiveDependencies: only run when confirmedNavigation changes */
  useEffect(() => {
    if (confirmedNavigation) {
      history.push(lastLocation || "");
      setConfirmedNavigation(false);
    }
  }, [confirmedNavigation]);

  useEffect(() => {
    /* automatically close modal if "when" prop is false before selection is made */
    if (!props.when) {
      setModalVisible(false);
    }
  }, [props.when]);

  return (
    <>
      <Prompt
        when={props.when}
        message={(location) => handleBlockedNavigation(location.pathname)}
      />

      <Modal show={modalVisible}>
        <div className={styles.container}>
          <div className={styles.header}>{props.title}</div>
          <div className={styles.body}>{props.message}</div>
          <div className={styles.footer}>
            <Button variant="link" onClick={() => setModalVisible(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={handleConfirmNavigationClick}
            >
              Leave Anyway
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
